import ResizeObserver from 'resize-observer-polyfill';
import './util/polyfill';

window.USER_ROLES = Object.freeze({
  NO_ACCESS: 0,
  VIEWER: 1,
  ACCOUNT_MANAGER: 9,
  SUPER_MANAGER: 99,
  ADMIN: 999
});

if ('ResizeObserver' in window) {
  // already exists
} else {
  window.ResizeObserver = ResizeObserver;
}

import './scripts/global-functions';
import PubSub from "pubsub-js";

import SiteMessagesInstance from "./components/site-messages";

// templates
import './templates/login';
import './templates/sso-callback';
import './templates/dashboard';
import './templates/forgot-password';
import CacheInstance from "./components/cache";
import { isPolicyHolderEnterprise, showSupportPhone } from './util/enterprise-branding';
import askForProfileName from './scripts/profile-prompt';
import { mitigationLabel } from './util/mitigation-label';
import { hasFeature } from './util/plan-features';

window.PubSub = PubSub;

const $ = window.$;

let resizeDebounce = null;

$(document).ready(() => {
  SiteMessagesInstance.displayMessages();
});

$(window).resize(() => {

  if(resizeDebounce) {
    clearTimeout(resizeDebounce);
  }

  resizeDebounce = setTimeout(() => {
    window.PubSub.publish('window.resize', window.innerWidth);
  }, 100);

});

$(".sidebar-close-expand-button").on("click", () => {

  let isMinimized = $(".app-menu").hasClass("is-minimized");

  if(isMinimized) {
    CacheInstance.save("sidebar_minimized", 0);
    $(".app-menu").removeClass("is-minimized");
    $(".app-contents").removeClass("is-minimized");

  } else {
    CacheInstance.save("sidebar_minimized", 1);
    $(".app-menu").addClass("is-minimized");
    $(".app-contents").addClass("is-minimized");

  }

});

const maybeShowMenuItems = (role) => {

  let isMinimized = CacheInstance.get("sidebar_minimized");

  if(isMinimized == null || isMinimized.value == 0) {
    $(".app-menu").removeClass("is-minimized");
    $(".app-contents").removeClass("is-minimized");
  } else if(isMinimized.value == 1) {
    $(".app-menu").addClass("is-minimized");
    $(".app-contents").addClass("is-minimized");
  }

  document
    .querySelectorAll('.app-menu__link')
    .forEach(link => {
      const reqRole = parseInt(link.dataset.role, 10);

      // Billing: once billing is open, and never inside the app
      if (link.dataset.for === 'billing' && (window.site.isApp || !window.currentUser || !window.currentUser.billing_open)) {
        return;
      }

      // a page of a feature the plan doesn't have
      if (link.dataset.feature && !hasFeature(link.dataset.feature)) {
        return;
      }

      if (role >= reqRole) {
        link.classList.remove('hide');
      }

    });
}

// the Mitigation link and tab, by the name the account gave the page (Settings › Display)
const nameMitigationLink = () => {
  const label = mitigationLabel();

  document.querySelectorAll('.app-menu__link[data-for="mitigation"]').forEach(link => {
    link.setAttribute('title', label);
    link.setAttribute('aria-label', label);
    const title = link.querySelector('.app-menu__link__title');
    if(title) title.textContent = label;
  });

  // the tab beside Map | Table | Upkeep
  document.querySelectorAll('.alert-map__views [data-view="mitigation"]').forEach(tab => {
    tab.textContent = label;
  });
};

window.PubSub.subscribe('mitigation_label', nameMitigationLink);

// the Dashboard's and the Map's view tabs (Table | Map | Upkeep | Mitigation)
// and the Mitigation line, for the features the plan includes
const hidePlanViews = () => {
  const off = {
    map: !hasFeature('map'),
    upkeep: !hasFeature('map'),
    mitigation: !hasFeature('mitigation'),
  };

  document.querySelectorAll('.alert-map__views [data-view]').forEach(tab => {
    if (off[tab.dataset.view]) tab.hidden = true;
  });

  if (off.mitigation) {
    document.querySelectorAll('[data-mitigation-summary]').forEach(link => link.remove());
  }

  // the Table tab alone isn't a switch
  document.querySelectorAll('.alert-map__views').forEach(views => {
    if (views.querySelectorAll('[data-view]:not([hidden])').length === 0) views.style.display = 'none';
  });
};

$(document).ready(() => {
  const account_role = CacheInstance.get('account_role');

  console.log({account_role});

});

window.PubSub.subscribe('user_authenticated', (evt, user) => {
  const sidebar = document.querySelector('.app-menu');
  if (sidebar) {
    const isSelective = isPolicyHolderEnterprise(user);
    sidebar.classList.toggle('app-menu--selective', isSelective);
    const artwork = isSelective
      ? 'sidebar-selective-winter.jpg'
      : 'sidebar-campus.jpg';
    sidebar.style.setProperty('--sidebar-art', `url('/assets/images/${artwork}')`);
  }
  showSupportPhone(user);
  CacheInstance.save('account_role', user.role);
  nameMitigationLink();
  hidePlanViews();
  maybeShowMenuItems(user.role);
  askForProfileName(user);
});
